// extracted by mini-css-extract-plugin
export default {"root":"_1AD-jjIe","content":"knOPd4QE","header":"_3XSfXdo6","sectionHeading":"DfxFfXSx","userName":"_36ZlDNjM","infoList":"_3fd5mQ_8","nav":"ZtJtqFe6"};